import { createActionGroup, props } from '@ngrx/store';

export const PostEscalationCurationActions = createActionGroup({
  source: 'PostEscalationCuration',
  events: {
    'Update Selected Items': props<{
      value: PostEscalationSelection;
    }>(),
  },
});
